import axiosInstance from '../utils/axiosInstance';

const BASE = '/admin/course-code-categories';

/**
 * List course codes assigned to a category.
 * Returns { category, data: [] }
 */
export async function listAssignedCourseCodes(categoryId) {
  const res = await axiosInstance.get(`${BASE}/${categoryId}/course-codes`);
  return res.data;
}

/**
 * List course codes NOT yet assigned to a category.
 * Supports optional search string.
 * Returns { data: [] }
 */
export async function listAvailableCourseCodes(categoryId, search = '') {
  const params = {};
  if (search && search.trim()) params.search = search.trim();
  const res = await axiosInstance.get(`${BASE}/${categoryId}/available-course-codes`, { params });
  return res.data;
}

/**
 * Assign a course code to a category.
 * Returns the created mapping row.
 */
export async function assignCourseCode(categoryId, courseCodeId) {
  const res = await axiosInstance.post(`${BASE}/${categoryId}/course-codes`, { courseCodeId });
  return res.data;
}

/**
 * Remove a course code assignment from a category.
 */
export async function unassignCourseCode(categoryId, courseCodeId) {
  const res = await axiosInstance.delete(`${BASE}/${categoryId}/course-codes/${courseCodeId}`);
  return res.data;
}
